import { homepageHeroes } from '@web-platform/shared-banana-redux/src/state/combinedResults';
import ErrorBoundary from '@web-platform/shared-universal-ui-error-boundary';
import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { useSelector } from 'react-redux';

import { HomepageHeroCard } from './HomepageHeroCard';

export const HomepageHeroContainer = () => {
  const homepageHeroData = useSelector(homepageHeroes);

  if (Object.keys(homepageHeroData).length > 1) {
    logWarn({
      component: 'HomepageHero',
      message: 'EFS returned more than 1 Homepage Heroes.',
      data: JSON.stringify(homepageHeroData),
    });
  }

  const homepageHero = Object.values(homepageHeroData).pop();
  if (!homepageHero) {
    return null;
  }

  return (
    <ErrorBoundary
      componentName="HomepageHeroCard"
      fallback={null}
      onError={({ component, error }) =>
        logWarn({
          component,
          error,
          message: 'A data error occurred while rendering the Homepage Hero.',
          data: JSON.stringify(homepageHeroData),
        })
      }
    >
      <HomepageHeroCard advert={homepageHero} />
    </ErrorBoundary>
  );
};
